var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChennaiSuperKingsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 298.19391,
    height: 245.86046,
    viewBox: "0 0 298.19391 245.86046",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("radialGradient", {
    fx: 0,
    fy: 0,
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(109.81964,0,0,-109.81963,157.58105,228.39746)",
    spreadMethod: "pad",
    id: "radialGradient26"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#fff200"
    },
    offset: 0,
    id: "stop28"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f25c19"
    },
    offset: 1,
    id: "stop30"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    fx: 0,
    fy: 0,
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(109.81859,0,0,-109.81857,157.58008,228.39941)",
    spreadMethod: "pad",
    id: "radialGradient46"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#fff200"
    },
    offset: 0,
    id: "stop48"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f25c19"
    },
    offset: 1,
    id: "stop50"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    fx: 0,
    fy: 0,
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(109.79942,0,0,-109.79942,157.58008,228.41602)",
    spreadMethod: "pad",
    id: "radialGradient66"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#fff200"
    },
    offset: 0,
    id: "stop68"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f25c19"
    },
    offset: 1,
    id: "stop70"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    fx: 0,
    fy: 0,
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(109.80414,0,0,-109.80414,157.58203,228.41211)",
    spreadMethod: "pad",
    id: "radialGradient86"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#fff200"
    },
    offset: 0,
    id: "stop88"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f25c19"
    },
    offset: 1,
    id: "stop90"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    fx: 0,
    fy: 0,
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(109.83032,0,0,-109.83031,157.58008,228.38379)",
    spreadMethod: "pad",
    id: "radialGradient106"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#fff200"
    },
    offset: 0,
    id: "stop108"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f25c19"
    },
    offset: 1,
    id: "stop110"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    fx: 0,
    fy: 0,
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(109.84024,0,0,-109.84024,157.58008,228.375)",
    spreadMethod: "pad",
    id: "radialGradient126"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#fff200"
    },
    offset: 0,
    id: "stop128"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f25c19"
    },
    offset: 1,
    id: "stop130"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    fx: 0,
    fy: 0,
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(109.81812,0,0,-109.8181,157.58301,228.39551)",
    spreadMethod: "pad",
    id: "radialGradient146"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#fff200"
    },
    offset: 0,
    id: "stop148"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f25c19"
    },
    offset: 1,
    id: "stop150"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    fx: 0,
    fy: 0,
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(109.81789,0,0,-109.81789,157.58008,228.39648)",
    spreadMethod: "pad",
    id: "radialGradient166"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#fff200"
    },
    offset: 0,
    id: "stop168"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f25c19"
    },
    offset: 1,
    id: "stop170"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    fx: 0,
    fy: 0,
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(109.82091,0,0,-109.82089,157.58008,228.39258)",
    spreadMethod: "pad",
    id: "radialGradient186"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#fff200"
    },
    offset: 0,
    id: "stop188"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f25c19"
    },
    offset: 1,
    id: "stop190"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    fx: 0,
    fy: 0,
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(109.81044,0,0,-109.81044,157.59277,228.39551)",
    spreadMethod: "pad",
    id: "radialGradient206"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#fff200"
    },
    offset: 0,
    id: "stop208"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f25c19"
    },
    offset: 1,
    id: "stop210"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    fx: 0,
    fy: 0,
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(109.81898,0,0,-109.81897,157.58105,228.58301)",
    spreadMethod: "pad",
    id: "radialGradient226"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#fff200"
    },
    offset: 0,
    id: "stop228"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f25c19"
    },
    offset: 1,
    id: "stop230"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    fx: 0,
    fy: 0,
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(109.82004,0,0,-109.82004,157.58008,228.39648)",
    spreadMethod: "pad",
    id: "radialGradient246"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#fff200"
    },
    offset: 0,
    id: "stop248"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f25c19"
    },
    offset: 1,
    id: "stop250"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    fx: 0,
    fy: 0,
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(109.82024,0,0,-109.82022,157.58008,228.39355)",
    spreadMethod: "pad",
    id: "radialGradient266"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#fff200"
    },
    offset: 0,
    id: "stop268"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f25c19"
    },
    offset: 1,
    id: "stop270"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    fx: 0,
    fy: 0,
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(109.81873,0,0,-109.81873,157.58008,228.39551)",
    spreadMethod: "pad",
    id: "radialGradient286"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#fff200"
    },
    offset: 0,
    id: "stop288"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f25c19"
    },
    offset: 1,
    id: "stop290"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    fx: 0,
    fy: 0,
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(104.70369,0,0,-104.70367,164.74121,228.4043)",
    spreadMethod: "pad",
    id: "radialGradient306"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#fff200"
    },
    offset: 0,
    id: "stop308"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f25c19"
    },
    offset: 1,
    id: "stop310"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    fx: 0,
    fy: 0,
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(109.82892,0,0,-109.8289,157.55371,228.38965)",
    spreadMethod: "pad",
    id: "radialGradient326"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#fff200"
    },
    offset: 0,
    id: "stop328"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f25c19"
    },
    offset: 1,
    id: "stop330"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    fx: 0,
    fy: 0,
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(109.82137,0,0,-109.82137,157.58008,228.39258)",
    spreadMethod: "pad",
    id: "radialGradient346"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#fff200"
    },
    offset: 0,
    id: "stop348"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f25c19"
    },
    offset: 1,
    id: "stop350"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    fx: 0,
    fy: 0,
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(109.8092,0,0,-109.8092,157.58008,228.40723)",
    spreadMethod: "pad",
    id: "radialGradient366"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#fff200"
    },
    offset: 0,
    id: "stop368"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f25c19"
    },
    offset: 1,
    id: "stop370"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    fx: 0,
    fy: 0,
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(109.81905,0,0,-109.81903,157.58105,228.39355)",
    spreadMethod: "pad",
    id: "radialGradient386"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#fff200"
    },
    offset: 0,
    id: "stop388"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f25c19"
    },
    offset: 1,
    id: "stop390"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath398"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,595.276 841.89,0 L 841.89,0 0,0 0,595.276 z",
    id: "path400"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,-53.307495,-53.307495,0,362.85107,299.43066)",
    spreadMethod: "pad",
    id: "linearGradient418"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#00adef"
    },
    offset: 0,
    id: "stop420"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#1d418c"
    },
    offset: 1,
    id: "stop422"
  })), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath430"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,595.276 841.89,0 L 841.89,0 0,0 0,595.276 z",
    id: "path432"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,-53.307495,-53.307495,0,414.71533,299.43066)",
    spreadMethod: "pad",
    id: "linearGradient450"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#00adef"
    },
    offset: 0,
    id: "stop452"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#1d418c"
    },
    offset: 1,
    id: "stop454"
  })), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath462"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,595.276 841.89,0 L 841.89,0 0,0 0,595.276 z",
    id: "path464"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,-52.525879,-52.525879,0,474.11523,298.1123)",
    spreadMethod: "pad",
    id: "linearGradient482"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#00adef"
    },
    offset: 0,
    id: "stop484"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#1d418c"
    },
    offset: 1,
    id: "stop486"
  })), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath494"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,595.276 841.89,0 L 841.89,0 0,0 0,595.276 z",
    id: "path496"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,-53.307495,-53.307495,0,524.41406,299.43066)",
    spreadMethod: "pad",
    id: "linearGradient514"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#00adef"
    },
    offset: 0,
    id: "stop516"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#1d418c"
    },
    offset: 1,
    id: "stop518"
  })), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath526"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,595.276 841.89,0 L 841.89,0 0,0 0,595.276 z",
    id: "path528"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,-53.320938,-53.320938,0,581.65332,299.45312)",
    spreadMethod: "pad",
    id: "linearGradient546"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#00adef"
    },
    offset: 0,
    id: "stop548"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#1d418c"
    },
    offset: 1,
    id: "stop550"
  })), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath558"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,595.276 841.89,0 L 841.89,0 0,0 0,595.276 z",
    id: "path560"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,-46.412125,-46.412125,0,347.84131,197.85352)",
    spreadMethod: "pad",
    id: "linearGradient582"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#00adef"
    },
    offset: 0,
    id: "stop584"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#1d418c"
    },
    offset: 1,
    id: "stop586"
  })), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath594"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,595.276 841.89,0 L 841.89,0 0,0 0,595.276 z",
    id: "path596"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,-46.412109,-46.412109,0,428.34473,197.86621)",
    spreadMethod: "pad",
    id: "linearGradient614"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#00adef"
    },
    offset: 0,
    id: "stop616"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#1d418c"
    },
    offset: 1,
    id: "stop618"
  })), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath626"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,595.276 841.89,0 L 841.89,0 0,0 0,595.276 z",
    id: "path628"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,-46.412125,-46.412125,0,495.95898,197.96777)",
    spreadMethod: "pad",
    id: "linearGradient646"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#00adef"
    },
    offset: 0,
    id: "stop648"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#1d418c"
    },
    offset: 1,
    id: "stop650"
  })), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath658"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,595.276 841.89,0 L 841.89,0 0,0 0,595.276 z",
    id: "path660"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,-46.412155,-46.412155,0,636.02148,197.95605)",
    spreadMethod: "pad",
    id: "linearGradient678"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#00adef"
    },
    offset: 0,
    id: "stop680"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#1d418c"
    },
    offset: 1,
    id: "stop682"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,-44.166,-44.166,0,572.99414,195.77539)",
    spreadMethod: "pad",
    id: "linearGradient698"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#00adef"
    },
    offset: 0,
    id: "stop700"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#1d418c"
    },
    offset: 1,
    id: "stop702"
  })), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath710"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,595.276 841.89,0 L 841.89,0 0,0 0,595.276 z",
    id: "path712"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "matrix(1.25,0,0,-1.25,-115.53269,275.69546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3548",
    transform: "matrix(0.37338186,0,0,0.37338186,59.253585,15.663213)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path32",
    style: {
      fill: "url(#radialGradient26)",
      stroke: "none"
    },
    d: "m 345.37,383.121 c -10.911,-5.608 -24.167,-6.731 -35.723,-9.364 l 0,0 c 1.093,-2.309 5.375,-2.185 9.111,-2.06 l 0,0 c 1.643,0.054 3.181,0.109 4.297,-0.042 l 0,0 c -12.189,-6.413 -20.872,-14.102 -28.005,-25.169 l 0,0 c -4.333,-3.047 -6.495,-8.269 -8.973,-12.772 l 0,0 c -1.506,-2.733 -4.252,-5.777 -2.897,-8.662 l 0,0 c 2.68,0.944 15.235,22.186 36.306,26.656 l 0,0 c -0.967,-1.033 -7.046,-8.77 -8.675,-11.543 l 0,0 c -4.098,-6.978 -6.929,-13.893 -9.413,-22.032 l 0,0 c -2.643,-8.663 -3.358,-17.9 -4.8,-24.46 l 0,0 c -0.523,-2.369 -2.455,-4.789 -1.403,-7.334 l 0,0 c 2.011,0.754 2.94,3.557 3.956,5.54 l 0,0 c 3.522,6.868 6.453,14.362 12.065,19.043 l 0,0 c 0.035,-0.4 -0.282,-0.5 -0.333,-0.832 l 0,0 c -9.483,-19.47 -4.789,-52.363 0.434,-73.357 l 0,0 c 0.991,0.438 0.823,-1.928 1.825,-2.656 l 0,0 c -0.891,17.323 -6.181,34.732 -4.604,50.954 l 0,0 c 1.418,14.559 6.991,27.054 13.346,37.597 l 0,0 c -4.032,0.265 -7.983,-3.2 -10.728,-6.098 l 0,0 c -4.171,-4.402 -6.754,-11.053 -10.47,-14.097 l 0,0 c 4.301,21.208 16.379,39.755 31.017,51.888 l 0,0 c 2.015,1.67 17.264,6.852 15.413,12.499 l 0,0 c -0.837,-1.49 -1.629,-1.868 -2.625,-2.22 l 0,0 c -6.253,-2.217 -13.754,-2.847 -20.451,-4.895 l 0,0 c -8.157,-2.494 -14.497,-6.739 -20.49,-9.31 l 0,0 c 5.224,8.798 15.874,14.937 21.862,21.856 l 0,0 c 11.876,1.666 20.12,6.411 25.77,13.355 l 0,0 c -0.382,0.117 -0.735,0.169 -1.065,0.169 l 0,0 c -1.952,0 -3.105,-1.812 -4.747,-2.654"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g42"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path52",
    style: {
      fill: "url(#radialGradient46)",
      stroke: "none"
    },
    d: "m 232.098,365.761 c -0.657,-0.062 -7.578,-2.091 -10.589,-2.879 l 0,0 c -1.715,-0.448 -4.257,-1.665 -5.082,-1.622 l 0,0 c -0.216,0.012 0.037,0.891 -0.465,0.765 l 0,0 c -2.127,-0.539 -4.04,-1.924 -6.21,-2.519 l 0,0 c -6.272,-1.718 -13.748,-2.8 -18.228,-7.518 l 0,0 c -1.499,-0.212 -3.627,0.109 -3.487,-1.49 l 0,0 c 1.607,-1.747 5.129,-0.862 7.268,-0.605 l 0,0 c 6.389,0.77 13.405,4.171 19.525,6.422 l 0,0 c 2.929,1.08 6.642,2.717 10.128,3.644 l 0,0 c 5.49,1.46 11.463,3.07 16.499,4.167 l 0,0 c 20.843,4.536 41.805,6.835 64.037,6.483 l 0,0 c -6.758,0.752 -13.42,1.087 -20.017,1.087 l 0,0 c -18.163,0 -35.801,-2.544 -53.379,-5.935"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g56"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g62"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path72",
    style: {
      fill: "url(#radialGradient66)",
      stroke: "none"
    },
    d: "m 138.871,343.637 c 0.142,-0.561 0.712,-0.619 0.895,-1.129 l 0,0 c 1.708,1.144 4.153,1.666 4.915,3.612 l 0,0 c -0.531,0.046 -1.064,0.08 -1.582,0.08 l 0,0 c -1.897,0 -3.588,-0.464 -4.228,-2.563"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g74"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g76"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g82"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g84"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path92",
    style: {
      fill: "url(#radialGradient86)",
      stroke: "none"
    },
    d: "m 174.39,345.763 c 0.469,-0.03 0.485,-0.594 0.496,-1.163 l 0,0 c 1.95,-0.213 4.871,-0.49 6.041,-0.302 l 0,0 c 0.521,1.781 2.985,1.916 3.29,3.879 l 0,0 c -0.904,0.56 -2.049,0.821 -3.248,0.821 l 0,0 c -2.566,0 -5.375,-1.198 -6.579,-3.235"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g94"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g96"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g102"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path112",
    style: {
      fill: "url(#radialGradient106)",
      stroke: "none"
    },
    d: "m 163.066,342.022 c 1.044,-3.745 5.532,-2.409 8.993,-2.067 l 0,0 c 0.356,1.291 -0.704,0.917 -0.926,1.529 l 0,0 c 0.609,0.842 2.247,0.811 1.794,2.554 l 0,0 c -0.902,0.711 -1.908,0.992 -2.936,0.992 l 0,0 c -2.609,0 -5.361,-1.811 -6.925,-3.008"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path132",
    style: {
      fill: "url(#radialGradient126)",
      stroke: "none"
    },
    d: "m 153.501,336.42 c -0.006,-1.175 1.002,-1.149 0.995,-2.323 l 0,0 c 1.506,1.582 3.513,0.46 4.185,2.751 l 0,0 c -0.366,0.494 -0.999,0.681 -1.71,0.681 l 0,0 c -1.273,0 -2.794,-0.601 -3.47,-1.109"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g144"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path152",
    style: {
      fill: "url(#radialGradient146)",
      stroke: "none"
    },
    d: "m 196.985,334.391 c -0.543,-0.038 -1.326,-0.016 -2.247,0.007 l 0,0 c -1.78,0.042 -4.077,0.085 -6.152,-0.299 l 0,0 c 0.366,-2.336 2.264,-2.868 3.913,-3.687 l 0,0 c 2.975,1.554 5.3,3.659 9.697,4.006 l 0,0 c -0.878,1.443 -2.859,1.583 -4.945,1.598 l 0,0 c -0.931,-0.609 0.561,-1.445 -0.266,-1.625"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g154"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g164"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path172",
    style: {
      fill: "url(#radialGradient166)",
      stroke: "none"
    },
    d: "m 176.865,330.324 c 0.97,-3.399 4.054,-2.854 6.703,-3.457 l 0,0 c 1.043,1.833 3.109,2.797 4.021,4.743 l 0,0 c -0.514,0.037 -0.999,0.054 -1.463,0.054 l 0,0 c -3.47,0 -5.692,-0.94 -9.261,-1.34"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g174"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g176"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g182"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path192",
    style: {
      fill: "url(#radialGradient186)",
      stroke: "none"
    },
    d: "m 201.328,330.338 c -0.398,-0.033 -0.445,-0.364 -0.764,-0.464 l 0,0 c 0.089,-1.063 0.176,-2.126 0.264,-3.188 l 0,0 c 2.852,-3.167 6.49,-0.962 9.295,-0.837 l 0,0 c 7.377,0.324 14.817,-1.708 21.872,-2.609 l 0,0 c 14.126,-1.807 26.162,-4.399 38.794,-8.432 l 0,0 c 6.313,-2.017 12.634,-4.241 18.885,-5.262 l 0,0 c -25.262,11.142 -53.848,20.801 -86.722,20.8 l 0,0 c -0.538,0 -1.083,-0.003 -1.624,-0.008"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g194"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path212",
    style: {
      fill: "url(#radialGradient206)",
      stroke: "none"
    },
    d: "m 284.314,291.857 c 0.019,-0.509 -0.467,-0.592 -0.301,-1.226 l 0,0 c 11.523,-18.784 11.949,-50.848 14.905,-73.769 l 0,0 c 2.478,15.791 0.971,41.199 -3.697,59.451 l 0,0 c -1.267,4.955 -5.888,15.631 -10.242,15.63 l 0,0 c -0.223,0 -0.445,-0.028 -0.665,-0.086"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g222"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path232",
    style: {
      fill: "url(#radialGradient226)",
      stroke: "none"
    },
    d: "m 389.833,512.109 c -37.325,-9.843 -71.229,-25.761 -79.158,-63.267 l 0,0 c 3.723,3.314 5.19,8.615 7.746,13.072 l 0,0 c 1.371,2.39 2.758,4.191 4.288,6.37 l 0,0 c 1.491,2.125 3.316,4.605 3.489,6.302 l 0,0 c 1.511,3.141 9.138,9.464 13.455,11.938 l 0,0 c 37.712,21.618 79.324,24.551 91.915,38.06 l 0,0 c -2.157,-4.674 -7.628,-8.281 -11.86,-11.806 l 0,0 c -58.541,-11.502 -81.016,-57.789 -84.237,-63.095 l 0,0 c 9.742,6.408 40.029,62.759 123.14,63.093 l 0,0 c 10.424,0.042 23.763,0.342 33.597,5.979 l 0,0 c -6.222,-8.946 -22.87,-6.97 -32.177,-13.482 l 0,0 c 15.685,3.57 39.764,4.539 55.84,8.614 l 0,0 c -5.858,-5.443 -16.359,-9.119 -25.373,-13.321 l 0,0 c -8.415,-3.924 -20.309,-4.488 -30.776,-6.147 l 0,0 c -65.583,-10.391 -82.654,-46.401 -81.799,-48.855 l 0,0 c 6.129,4.609 17.733,26.025 67.017,38.412 l 0,0 c 17.537,4.408 36.078,3.791 54.243,3.669 l 0,0 c 33.21,-0.223 65.506,-14.964 98.781,-6.295 l 0,0 c -13.437,-8.884 -25.212,-12.121 -42.704,-17.155 l 0,0 C 486.978,481.6 446.918,453.63 444.514,450.251 l 0,0 c 2.019,-0.459 18.949,6.729 24.867,7.988 l 0,0 c 55.939,11.91 98.76,-2.051 139.437,-16.099 l 0,0 c 0,0 18.058,-7.418 42.315,-7.341 l 0,0 c -16.292,-12.225 -40.864,-20.231 -65.311,-20.223 l 0,0 c -14.111,6.719 -30.428,12.494 -48.248,16.075 l 0,0 c -10.761,2.162 -21.019,4.18 -33.623,4.046 l 0,0 c -2.535,-0.028 -5.251,0.04 -8.052,0.106 l 0,0 c -9.092,0.217 -19.074,0.435 -26.637,-2.565 l 0,0 c 1.919,-1.601 6.92,-0.954 9.291,-0.838 l 0,0 c 25.18,1.234 53.443,-3.478 73.882,-10.754 l 0,0 c 27.214,-9.688 49.783,-22.436 71.798,-38.998 l 0,0 c 16.265,-12.241 30.235,-31.346 52.014,-37.423 l 0,0 c -3.484,-0.615 -6.683,-1.103 -10.325,-1.253 l 0,0 c -9.021,-0.37 -19.215,0.127 -25.923,3.077 l 0,0 c -5.389,2.373 -43.152,29.201 -45.414,30.346 l 0,0 c 2.31,-4.707 52.916,-41.458 75.202,-55.964 l 0,0 c -2.217,-1.091 -34.689,11.556 -50.14,19.529 l 0,0 c 0.116,-1.757 11.221,-11.203 15.322,-15.584 l 0,0 c 10.522,-11.235 18.966,-25.985 26.155,-39.954 l 0,0 c 10.924,-21.221 20.478,-48.186 34.199,-64.557 l 0,0 c -3.786,0.339 -13.261,7.077 -15.561,8.742 l 0,0 c -2.142,1.552 -4.542,4.363 -6.703,3.458 l 0,0 c -0.474,-1.831 1.809,-3.073 2.787,-4.583 l 0,0 c 3.129,-4.845 5.383,-13.033 7.316,-20.654 l 0,0 c 3.961,-15.614 6.531,-30.197 11.215,-43.591 l 0,0 c -4.602,4.946 -8.115,10.668 -12.9,15.378 l 0,0 c -2.757,2.716 -12.424,13.332 -14.301,8.045 l 0,0 c -0.163,-3.172 2.434,-11.789 2.646,-12.615 l 0,0 c 2.416,-9.471 7.188,-20.06 11.625,-29.122 l 0,0 c 3.231,-6.592 7.881,-14.229 11.734,-20.69 l 0,0 c 4.772,-7.998 17.828,-24.085 18.733,-22.919 l 0,0 c -4.859,5.97 -8.909,14.292 -13.161,18.567 l 0,0 c -7.294,14.123 -18.405,35.315 -21.759,54.756 l 0,0 c 12.72,-9.389 18.072,-22.496 29.033,-34.416 l 0,0 c 2.001,-1.295 4.861,-7.009 5.555,-9.005 l 0,0 c 0.708,3.505 -3.689,10.375 -5.272,13.751 l 0,0 c -1.441,3.073 -2.564,5.808 -2.748,9 l 0,0 c -7.703,20.248 -9.296,40.833 -16.109,64.045 l 0,0 c 7.794,-3.773 17.956,-7.225 27.977,-8.523 l 0,0 c 3.346,-0.433 6.84,-1.696 9.258,-0.441 l 0,0 c -3.192,0.989 -5.008,2.395 -5.008,2.395 l 0,0 c -31.798,27.52 -46.622,73.707 -70.674,108.076 l 0,0 c 13.101,-5.456 37.655,-10.485 50.804,-4.555 l 0,0 c -10.055,0.516 -17.376,3.109 -21.916,5.157 l 0,0 c -4.942,2.229 -10.423,6.822 -14.904,9.775 l 0,0 c -4.911,3.238 -9.951,5.96 -14.033,9.672 l 0,0 c 8.345,-3.192 42.344,-10.423 62.378,7.148 l 0,0 c 1.086,0.952 2.96,1.68 3.754,3.118 l 0,0 c -32.396,-9.103 -81.385,33.448 -87.621,38.331 l 0,0 c -3.818,2.994 -7.232,5.617 -8.303,6.298 l 0,0 c -2.79,1.774 -5.305,3.949 -8.094,5.752 l 0,0 c -5.983,3.862 -13.053,6.264 -18.547,10.902 l 0,0 c 6.172,-0.724 12.176,0.305 17.893,1.877 l 0,0 c 0.771,-0.257 11.788,1.539 17.363,3.436 l 0,0 c 23.044,7.843 38.856,26.749 58.753,36.529 l 0,0 c -7.974,1.388 -18.729,-6.857 -42.23,-8.294 l 0,0 c -24.707,-1.511 -37.227,4.909 -44.308,7.175 l 0,0 c -4.209,1.347 -28.14,8.573 -34.479,9.59 l 0,0 c 43.646,8.348 58.598,40.802 58.598,40.802 l 0,0 c -6.068,-5.765 -9.608,-7.484 -9.608,-7.484 l 0,0 c -8.726,-4.505 -20.467,-6.22 -30.279,-7.31 l 0,0 c -7.334,-0.815 -23.011,1.579 -40.968,3.973 l 0,0 c -16.559,2.208 -35.058,4.416 -50.739,4.107 l 0,0 c 9.327,3.871 17.543,6.895 25.502,11.729 l 0,0 c 9.55,5.798 18.75,14.273 22.461,24.31 l 0,0 C 528.996,520 503.972,515.562 492.236,513.543 l 0,0 c 7.444,5.974 14.299,10.134 17.546,20.697 l 0,0 c -21.389,-17.001 -52.77,-14.457 -81.842,-19.18 l 0,0 c 0,0 13.727,12.216 24.023,30.107 l 0,0 c 0,0 -27.99,-24.691 -62.13,-33.058"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g234"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g236"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g242"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g244"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path252",
    style: {
      fill: "url(#radialGradient246)",
      stroke: "none"
    },
    d: "m 333.262,505.65 c 4.322,5.608 12.026,10.301 13.426,17.15 l 0,0 c -7.289,-7.111 -17.227,-12.162 -25.276,-19.331 l 0,0 c -8.127,-7.234 -14.111,-16.214 -20.437,-24.545 l 0,0 c 1.385,10.933 10.535,17.249 14.826,24.484 l 0,0 c -14.805,-7.85 -22.568,-21.07 -24.151,-23.247 l 0,0 c -6.363,-8.742 -7.109,-20.793 -13.172,-29.962 l 0,0 c -4.854,6.508 -1.125,13.532 1.611,19.382 l 0,0 C 265.037,463.33 269.44,441.387 244.843,432.934 l 0,0 c -3.974,-1.366 -8.628,-3.779 -12.62,-5.651 l 0,0 c -4.833,-2.262 -10.219,-4.193 -13.563,-7.346 l 0,0 c -1.892,-1.783 -8.289,-10.543 -9.661,-12.366 l 0,0 c -1.466,-1.945 -2.564,-4.419 -3.922,-5.938 l 0,0 c -2.036,-2.273 -4.712,-1.933 -7.662,-1.593 l 0,0 c -1.497,0.172 -3.065,0.345 -4.655,0.176 l 0,0 c -10.93,-1.155 -20.611,-10.751 -35.429,-12.947 l 0,0 c -1.267,-0.187 -2.56,-0.159 -3.877,-0.132 l 0,0 c -1.221,0.026 -2.462,0.051 -3.723,-0.093 l 0,0 c -5.472,-0.626 -11.021,-2.794 -15.705,-4.101 l 0,0 c -10.715,-2.991 -17.384,-6.775 -26.732,-11.429 l 0,0 c -5.266,-2.625 -12.24,-6.613 -14.016,-9.979 l 0,0 c -3.413,-6.468 4.301,-12.594 7.785,-16.604 l 0,0 c 1.272,-9.233 5.952,-7.259 7.796,-6.978 l 0,0 c 2.914,-3.024 1.916,-6.1 2.446,-10.225 l 0,0 c 1.955,-15.19 7.499,-22.372 18.299,-27.368 l 0,0 c 2.788,-5.975 1.902,-16.317 4.295,-22.908 l 0,0 c 2.814,-7.744 7.243,-15.79 11.334,-20.723 l 0,0 c -2.516,8.232 -4.897,20.174 -3.096,27.819 l 0,0 c 1.351,1.735 2.993,4.649 3.093,6.272 l 0,0 c 0.308,-0.745 0.631,-0.344 0.961,0.055 l 0,0 c 0.198,0.24 0.398,0.479 0.6,0.474 l 0,0 c -0.546,-10.638 2.663,-19.919 6.183,-26.362 l 0,0 c 3.322,-6.075 6.051,-10.914 9.712,-15.642 l 0,0 c 1.986,-2.565 4.175,-5.382 6.535,-6.28 l 0,0 c 0.193,3.265 -3.065,4.456 -3.179,9.363 l 0,0 c -6.561,15.092 -7.926,44.547 7.813,51.178 l 0,0 c 2.374,-2.856 5.229,-7.9 9.322,-6.049 l 0,0 c 3.758,-7.512 8.291,-14.114 9.637,-24.473 l 0,0 c 2.494,-0.508 2.326,1.24 3.455,1.89 l 0,0 c 4.521,-8.071 8.887,-16.324 11.062,-27.163 l 0,0 c 0.646,-0.21 1.086,-0.106 1.465,-0.001 l 0,0 c 0.454,0.126 0.821,0.252 1.357,-0.168 l 0,0 c 3.277,-14.825 4.118,-24.293 3.452,-37.013 l 0,0 c -3.605,-1.066 -11.82,-8.865 -12.821,-9.88 l 0,0 c -1.46,-0.701 -12.103,-13.644 -18.807,-20.001 l 0,0 c -4.181,7.166 -4.691,20.514 -3.891,27.755 l 0,0 c -1.744,-1.248 -3.309,-3.758 -4.321,-5.971 l 0,0 c -5.671,-12.406 -5.698,-32.534 -2.363,-44.311 l 0,0 c -8.58,4.603 -14.145,27.385 -11.484,37.153 l 0,0 c -5.671,-3.472 -8.343,-14.47 -8.155,-22.73 l 0,0 c 0.236,-10.276 7.07,-15.205 8.214,-21.782 l 0,0 c -1.303,-13.661 -9.016,-24.137 -2.488,-37.906 l 0,0 c 2.62,-5.532 12.678,-12.833 12.762,-18.6 l 0,0 c 0.591,1.195 0.372,-0.073 0.327,-1.34 l 0,0 c -0.036,-1.014 0.039,-2.03 0.733,-1.78 l 0,0 c 2.383,2.95 3.294,8.175 1.704,13.375 l 0,0 c 3.986,-4.405 9.009,-9.182 10.143,-16.01 l 0,0 c 0.944,-5.685 -2.59,-10.359 -1.905,-15.798 l 0,0 c 5.888,5.259 6.585,14.922 8.915,23.195 l 0,0 c 6.431,-7.884 14.827,-14.697 12.455,-29.456 l 0,0 c 3.427,5.371 4.581,11.485 1.944,20.214 l 0,0 c -1.661,5.498 -6.523,10.076 -5.364,16.405 l 0,0 c 1.327,-3.973 5.305,-4.814 8.925,-6.082 l 0,0 c 0.773,-1.568 1.474,-3.215 3.481,-3.323 l 0,0 c -1.711,4.829 -4.946,7.859 -5.93,13.547 l 0,0 c 4.855,-2.61 10.659,-5.83 17.258,-4.995 l 0,0 c 2.715,-2.915 5.439,-5.821 9.785,-6.812 l 0,0 c 0.396,2.059 -1.979,1.625 -3.018,2.559 l 0,0 c -5.22,4.68 -7.395,15.798 -5.588,24.004 l 0,0 c 0.526,-2.926 2.145,-5.573 3.477,-8.137 l 0,0 c 1.21,-2.326 2.1,-6.212 5.341,-6.376 l 0,0 c -2.02,9.009 -1.583,21.321 0.821,28.944 l 0,0 c 0.679,-2.743 2.418,-5.265 4.209,-7.274 l 0,0 c 1.692,-1.896 3.82,-4.625 6.003,-4.72 l 0,0 c -1.074,9.705 2.373,18.721 8.485,23.56 l 0,0 c 7.282,-3.796 10.392,-12.509 14.488,-20.06 l 0,0 c -3.199,-8.027 -6.372,-15.452 -6.395,-24.592 l 0,0 C 260.5,83.927 270.628,61.815 268.228,44.278 l 0,0 c -0.729,-5.326 -2.819,-14.342 -4.333,-20.41 l 0,0 c 2.369,3.507 5.493,12.795 5.72,13.306 l 0,0 c 6.281,14.098 0.613,41.528 -1.642,58.821 l 0,0 c 0.397,0.408 -0.43,16.991 2.245,21.442 l 0,0 c 4.393,-9.032 8.194,-18.691 11.091,-32.373 l 0,0 c -0.164,23.866 -7.112,44.506 -15.077,66.135 l 0,0 c -9.685,26.3 -5.133,55.824 2.893,81.653 l 0,0 c -4.629,-4.462 -7.204,-12.458 -9.212,-19.608 l 0,0 c -2.312,-8.234 -4.299,-20.465 -4.506,-28.045 l 0,0 c -0.275,-10.041 0.66,-19.612 2.064,-29.91 l 0,0 c -1.593,6.676 -8.261,0.929 -10.258,-2.049 l 0,0 c -3.888,-5.799 -5.921,-16.965 -7.787,-22.3 l 0,0 c -3.345,5.173 -2.271,11.801 -1.478,17.927 l 0,0 c -3.484,1.077 -4.231,-3.638 -5.117,-6.037 l 0,0 c -2.456,-6.637 -3.604,-15.151 -4.103,-23.198 l 0,0 c -0.935,4.589 -3.693,9.763 -4.801,14.441 l 0,0 c -0.899,3.792 -0.87,9.259 -5.835,7.541 l 0,0 c 2.14,-14.556 -1.143,-24.742 2.225,-36.714 l 0,0 c -6.149,-0.512 -10.148,5.209 -12.374,9.008 l 0,0 c -1.514,2.582 -2.299,6.127 -4.144,6.477 l 0,0 c -3.154,-4.267 -0.311,-13.305 -0.114,-18.059 l 0,0 c -2.136,2.58 -3.074,6.574 -4.806,9.631 l 0,0 c -1.577,0.104 -2.284,-0.536 -3.12,-1.059 l 0,0 c 1.323,-8.994 1.134,-15.029 4.96,-21.25 l 0,0 c -7.117,5.837 -10.841,17.639 -12.821,29.024 l 0,0 c -0.796,4.578 -0.661,7.383 -3.243,10.161 l 0,0 c -2.035,0.526 -3.221,-0.665 -4.252,-1.955 l 0,0 c 0.393,-2.889 1.129,-8.433 1.553,-9.098 l 0,0 c 1.897,-8.745 6.852,-17.393 4.192,-26.526 l 0,0 c -0.846,2.579 -0.634,5.079 -1.388,7.106 l 0,0 c -2.821,7.582 -9.221,9.292 -13.597,14.12 l 0,0 c -1.571,1.732 -1.327,4.122 -3.646,5.312 l 0,0 c -1.733,-4.738 2.489,-11.299 2.971,-16.6 l 0,0 c -7.261,7.408 -13.544,27.214 -6.769,38.347 l 0,0 c 1.451,-0.801 4.221,-1.256 5.675,-0.737 l 0,0 c 8.096,-3.669 17.175,-3.719 27.018,-1.782 l 0,0 c 3.982,2.728 7.235,6.593 10.928,8.52 l 0,0 c 6.087,9.762 8.989,19.417 16.223,27.006 l 0,0 c 0.309,-0.945 1.577,-0.762 2.487,-0.998 l 0,0 c 7.173,7.753 14.214,15.618 19.177,25.245 l 0,0 c 0.395,-0.553 0.444,-1.517 1.692,-1.065 l 0,0 c 1.064,3.545 4.258,5.282 5.285,8.858 l 0,0 c -3.601,11.197 -7.817,21.665 -10.06,34.465 l 0,0 c 0.287,1.453 1.479,3.188 0.07,4.017 l 0,0 c -1.046,0.638 -1.454,-0.144 -1.835,-0.926 l 0,0 c -0.372,-0.764 -0.721,-1.528 -1.619,-0.964 l 0,0 c 1.013,3.539 -1.336,7.835 -0.521,11.188 l 0,0 c -0.755,0.032 -1.295,-0.495 -1.761,-1.02 l 0,0 c -0.589,-0.664 -1.06,-1.327 -1.693,-0.871 l 0,0 c -0.57,4.697 1.471,8.3 1.007,12.117 l 0,0 c -0.883,0.64 -1.08,-0.075 -1.398,-0.788 l 0,0 c -0.238,-0.536 -0.545,-1.071 -1.259,-1.036 l 0,0 c -4.483,7.062 -2.418,20.124 -8.177,26.195 l 0,0 c -2.548,-1.869 -1.086,-4.877 -3.457,-6.7 l 0,0 c -0.556,8.344 -4.141,17.308 -8.874,24.936 l 0,0 c -4.832,7.786 -9.354,15.34 -17.417,11.8 l 0,0 c -1.469,0.888 -3.413,1.218 -4.247,2.859 l 0,0 c 2.483,0.699 5.345,-0.055 6.707,1.354 l 0,0 c -6.938,1.771 -20.051,0.755 -26.853,-0.209 l 0,0 c 3.393,-4.3 12.824,-1.482 16.857,-5.026 l 0,0 c -5.161,-5.099 -12.095,-2.769 -17.828,-2.673 l 0,0 c 0.378,-0.751 2.183,-2.051 1.792,-2.26 l 0,0 c -5.119,-0.21 -9.843,0.045 -13.011,2.137 l 0,0 c -0.402,1.433 -1.96,3.786 -3.417,2.525 l 0,0 c -0.725,-1.728 2.307,-3.073 2.517,-6.21 l 0,0 c -7.971,0.568 -11.828,5.052 -16.854,9.841 l 0,0 c -0.516,-2.182 1.638,-2.657 0.727,-3.951 l 0,0 c -4.974,-1.78 -10.619,-0.728 -13.774,1.672 l 0,0 c -6.033,4.59 -6.66,15.262 -10.604,21.585 l 0,0 c -0.954,-8.872 3.755,-18.216 6.948,-25.897 l 0,0 c -8.469,3.122 -7.941,16.856 -11.361,25.935 l 0,0 c 0.685,0.654 1.294,1.372 1.827,2.155 l 0,0 c -5.946,4.204 -13.919,6.019 -16.052,14.721 l 0,0 c 11.357,11.634 31.611,24.151 51.442,27.902 l 0,0 c 4.906,0.927 8.825,0.717 12.567,0.505 l 0,0 c 2.988,-0.169 5.864,-0.337 9.042,0.074 l 0,0 c 9.421,6.541 21.611,12.396 33.404,13.181 l 0,0 c 4.356,0.289 8.559,-0.301 11.488,1.75 l 0,0 c 4.371,3.057 6.059,13.559 10.603,17.318 l 0,0 c 20.35,16.835 50.368,18.221 55.753,24.248 l 0,0 c 9.315,10.422 13.404,34.212 14.67,36.102 l 0,0 c -0.95,-6.366 -2.176,-16.858 1.741,-21.113 l 0,0 c 2.259,20.727 14.79,37.827 28.458,48.87 l 0,0 c -3.99,-6.202 -10.532,-16.531 -9.615,-24.455 l 0,0 c 9.032,10.994 18.005,22.037 32.987,27.986 l 0,0 c 0.924,0.617 0.183,0.817 0.697,1.262 l 0,0 c 10.337,3.799 21.944,9.032 33.437,12.782 l 0,0 c -10.559,-11.226 -24.773,-13.963 -35.169,-20.946 l 0,0 c 3.526,0.764 9.944,2.345 15.272,4.467 l 0,0 c 9.763,3.884 19.087,9.591 25.11,16.507 l 0,0 c 2.384,2.737 3.782,6.166 6.082,8.924 l 0,0 c 2.466,2.957 6.099,5.362 6.813,9.786 l 0,0 C 387.014,523.45 353.75,519.877 333.262,505.65 m -60.919,-49.14 c 2.656,-5.01 3.159,-12.935 -1.474,-16.163 l 0,0 c 1.762,4.311 1.406,10.416 1.474,16.163 M 161.842,308.231 c 3.831,-0.58 6.803,-2.175 11.748,-1.437 l 0,0 c -1.646,-2.771 -6.7,-0.66 -8.962,-3.146 l 0,0 c 0.769,2.21 -2.165,2.685 -2.786,4.583 m 21.31,-0.649 c 8.347,0.778 16.437,-0.482 19.445,-7.221 l 0,0 c -0.347,-0.693 -1.656,-0.572 -2.324,-0.994 l 0,0 c 0.199,0.917 1.033,2.095 0.168,2.823 l 0,0 c -2.542,-0.192 -3.674,-1.58 -5.413,-2.452 l 0,0 c -3.838,4.032 -8.866,8.983 -14.303,3.231 l 0,0 c -1.501,2.305 -5.192,2.874 -6.736,3.859 l 0,0 c 3.381,0.881 6.652,1.257 8.831,-0.076 l 0,0 c 0.614,0.192 -0.407,0.674 0.332,0.83 m -45.582,-6.565 c 3.756,2.895 9.613,1.076 12.387,5.433 l 0,0 c 5.621,-1.36 7.035,-0.914 13.507,-3.299 l 0,0 c -7.015,-8.357 -9.251,-25.934 -4.683,-40.491 l 0,0 c -3.166,3.843 -6.875,12.591 -8.146,20.985 l 0,0 c -1.18,7.785 0.269,14.186 0.381,19.683 l 0,0 c -2.699,-0.799 -2.365,-4.171 -3.059,-6.669 l 0,0 c -1.727,0.492 -2.357,-0.325 -5.178,-0.428 l 0,0 c -0.332,2.233 -0.296,4.9 -2.784,4.584 l 0,0 c -0.681,-2.025 -1.2,-6.621 0.623,-7.569 l 0,0 c -0.899,-5.777 -2.757,-12.318 -2.969,-17.49 l 0,0 c -2.794,6.914 -5.434,21.131 -0.079,25.261 m 94.327,-88.48 c 0.984,-0.302 3.436,-0.187 2.521,-1.395 l 0,0 c 0.813,-0.162 1.059,0.157 1.305,0.477 l 0,0 c 0.213,0.278 0.427,0.557 1.019,0.516 l 0,0 c -0.622,-3.822 -6.166,-6.612 -7.941,-10.681 l 0,0 C 212.5,190.025 205.681,172.167 204.907,170.207 l 0,0 c -1.367,-3.456 -5.018,-9.328 -7.582,-15.063 l 0,0 c -6.137,3.687 -9.198,11.004 -12.698,17.804 l 0,0 c 8.06,13.09 16.999,27.277 31.729,33.497 l 0,0 c -3.328,-4.111 -9.017,-7.083 -10.501,-13.7 l 0,0 c 7.216,6.356 15.153,15.313 26.042,19.792 M 178.798,151.21 c -6.084,9.639 -8.587,28.814 -5.009,41.298 l 0,0 c 1.829,-17.517 9.773,-30.137 16.928,-39.914 l 0,0 c -2.445,-1.253 -5.204,-2.273 -7.905,-2.273 l 0,0 c -1.369,0 -2.724,0.262 -4.014,0.889 m -22.375,33.048 c 2.894,-11.009 5.794,-22.012 12.022,-29.091 l 0,0 c -11.895,0.424 -14.465,18.082 -12.022,29.091 m 11.783,-35.926 c 2.159,1.079 4.471,-1.424 6.938,-1.436 l 0,0 c -0.772,-0.254 -1.566,-0.37 -2.336,-0.37 l 0,0 c -1.92,0 -3.692,0.721 -4.602,1.806"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g254"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g264"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path272",
    style: {
      fill: "url(#radialGradient266)",
      stroke: "none"
    },
    d: "m 280.509,420.687 c -0.044,0.041 -1.131,0.131 -1.999,-0.071 l 0,0 c -10.296,-2.392 -55.971,-24.431 -74.745,-37.139 l 0,0 c -13.357,1.421 -26.286,-3.142 -36.253,-7.8 l 0,0 c -2.353,-1.099 -5.067,-1.759 -6.509,-3.747 l 0,0 c 0.367,-1.363 1.936,-1.31 3.504,-1.257 l 0,0 c 0.974,0.033 1.949,0.066 2.636,-0.24 l 0,0 c 9.192,5.592 21.165,11.953 34.398,10.856 l 0,0 c -1.094,-0.432 -20.654,-12.345 -11.5,-16.188 l 0,0 c 1.176,0.361 1.264,1.644 3.088,1.458 l 0,0 c 4.668,6.416 10.747,11.638 18.37,15.551 l 0,0 c 8.614,9.496 21.214,15.611 33.048,22.377 l 0,0 c -1.758,-2.957 -4.525,-5.057 -6.148,-8.126 l 0,0 c 0.716,-2.799 3.002,-3.744 4.11,-6.079 l 0,0 c -0.875,-1.852 -0.95,-4.382 -1.466,-6.538 l 0,0 c -2.855,0.897 -8.784,2.696 -10.953,1.504 l 0,0 c 0.055,-1.991 3.299,-2.005 4.148,-1.663 l 0,0 c 5.922,-1.862 10.006,-3.511 16.526,-5.858 l 0,0 c 2.022,3.738 6.498,5.73 11.425,7.36 l 0,0 c 6.535,2.162 13.494,1.53 20.382,0.877 l 0,0 c -0.663,2.57 -3.732,2.302 -6.238,2.695 l 0,0 c -5.468,2.208 -15.747,4.177 -24.859,4.768 l 0,0 c -1.22,1.619 -4.092,1.292 -5.44,2.76 l 0,0 c -2.427,5.202 4.441,9.403 5.786,12.509 l 0,0 c 8.509,4.59 16.829,7.221 25.603,10.532 l 0,0 c 2.434,0.921 5.422,1.158 7.337,3.414 l 0,0 c -1.878,-0.259 -3.536,-0.708 -4.251,-1.955 M 248.12,390.344 c -0.297,-0.49 -0.437,-1.113 -0.235,-2.026 l 0,0 c -0.531,-0.044 -1.062,-0.087 -1.593,-0.131 l 0,0 c -0.209,1.411 0.401,2.13 1.828,2.157 l 0,0 c 0,0 0,0 0,0 m 5.708,-1.135 c 2.524,-1.099 6.871,-0.052 8.595,-2.097 l 0,0 c -5.246,-0.573 -10.188,-2.871 -14.344,-5.998 l 0,0 c -1.878,0.12 -2.827,1.33 -4.547,1.632 l 0,0 c -0.241,1.81 0.44,2.838 0.868,4.08 l 0,0 c 0.948,-1.278 2.684,-1.926 4.409,-1.926 l 0,0 c 2.555,0 5.088,1.419 5.019,4.309"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g274"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g276"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g284"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path292",
    style: {
      fill: "url(#radialGradient286)",
      stroke: "none"
    },
    d: "m 174.206,362.592 c -3.715,0.883 -9.239,0.313 -11.323,-3.74 l 0,0 c 3.912,-5.119 9.642,1.067 12.118,3.806 l 0,0 c 3.03,-2.345 7.924,2.091 10.096,4.041 l 0,0 c -0.521,0.082 -1.065,0.121 -1.624,0.121 l 0,0 c -4.046,0 -8.755,-2.041 -9.267,-4.228"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g296"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g302"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g304"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path312",
    style: {
      fill: "url(#radialGradient306)",
      stroke: "none"
    },
    d: "m 290.471,236.619 c 0.641,-14.364 -0.96,-28.769 -4.682,-40.494 l 0,0 c 0.524,-5.697 -3.095,-8.48 -3.631,-14.335 l 0,0 c 0.048,-0.659 -0.758,-1.331 -0.3,-1.228 l 0,0 c 6.987,10.159 10.376,24.926 11.684,38.261 l 0,0 c 1.046,10.656 0.937,22.52 -1.531,33.163 l 0,0 c -0.784,3.386 -0.978,8.122 -4.438,10.062 l 0,0 c 0.51,-8.094 2.494,-16.373 2.898,-25.429"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g322"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g324"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path332",
    style: {
      fill: "url(#radialGradient326)",
      stroke: "none"
    },
    d: "m 350.518,422.849 c -1.859,-0.855 -7.854,-3.994 -12.507,-6.929 l 0,0 c -2.149,-1.355 -10.215,-7.118 -13.763,-10.962 l 0,0 c -7.489,-8.111 -10.608,-6.533 -10.068,-8.366 l 0,0 c 1.146,-1.179 2.323,-1.557 3.75,-1.696 l 0,0 c 6.345,-0.62 10.371,2.172 13.183,5.499 l 0,0 c 7.025,8.308 19.592,18.404 30.258,22.146 l 0,0 c 9.854,3.457 18.913,1.746 28.099,0.035 l 0,0 c 5.419,-1.009 10.882,-2.019 16.579,-1.965 l 0,0 c -8.21,3.887 -20.473,6.545 -32.458,6.545 l 0,0 c -8.306,0 -16.48,-1.278 -23.073,-4.307"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g334"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g336"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g342"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g344"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path352",
    style: {
      fill: "url(#radialGradient346)",
      stroke: "none"
    },
    d: "m 137.462,365.578 c -7.822,-1.264 -32.427,-6.267 -29.889,-16.902 l 0,0 c 0.63,-2.644 6.795,-5.829 10.484,-5.552 l 0,0 c 4.795,8.285 6.985,18.78 21.295,19.002 l 0,0 c 1.059,4.782 4.7,7.377 7.543,10.648 l 0,0 c -0.526,-0.039 -0.422,0.667 -0.862,0.73 l 0,0 c -2.202,-3.071 -7.794,-4.834 -8.571,-7.926"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g362"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g364"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path372",
    style: {
      fill: "url(#radialGradient366)",
      stroke: "none"
    },
    d: "m 147.442,351.562 c 4.782,-3.668 12.396,0.144 12.419,5.035 l 0,0 c -0.344,0.162 -0.777,0.236 -1.275,0.236 l 0,0 c -3.069,0 -8.615,-2.819 -11.144,-5.271"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g376"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g382"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g384"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path392",
    style: {
      fill: "url(#radialGradient386)",
      stroke: "none"
    },
    d: "m 213.465,314.492 c 1.961,-1.359 5.863,-1.659 5.206,-4.785 l 0,0 c 4.308,-1.304 4.336,-4.475 4.705,-8.434 l 0,0 c 12.239,-11.316 17.983,-30.172 26.883,-43.907 l 0,0 c -0.398,-0.033 -0.501,0.285 -0.829,0.335 l 0,0 c 2.008,-1.902 2.854,-4.788 4.874,-5.616 l 0,0 c -6.481,18.896 -13.574,36.582 -23.953,52.168 l 0,0 c -0.067,0.798 -0.132,1.595 -0.198,2.391 l 0,0 c -3.841,4.209 -8.897,6.987 -14.032,9.672 l 0,0 c -1.288,-0.265 -2.547,-0.559 -2.656,-1.824"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g394"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath398)",
    id: "g396"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(348.4629,220.5371)",
    id: "g402"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path404",
    style: {
      fill: "#1d418c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 16.777,0 -23.097,66.941 0,8.58 c 0,1.398 0.903,2.791 2.707,4.189 l -0.128,-0.098 c 0.945,0.733 1.807,1.279 2.582,1.647 0.775,0.362 1.634,0.546 2.578,0.546 l 33.808,0 0,-17.677 -6.191,4.593 -17.807,0 23.614,-67.661 0,-8.182 c 0,-0.602 -0.131,-1.235 -0.386,-1.899 -0.261,-0.666 -0.67,-1.296 -1.228,-1.895 -0.558,-0.598 -1.268,-1.081 -2.127,-1.449 -0.863,-0.364 -1.894,-0.547 -3.099,-0.547 l -34.454,0 0,17.406 L -0.515,0 0,0 z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g406"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g408"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g414"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g416"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path424",
    style: {
      fill: "url(#linearGradient418)",
      stroke: "none"
    },
    d: "m 349.882,300.464 c -0.615,0 -1.151,-0.112 -1.639,-0.339 l 0,0 c -0.587,-0.28 -1.302,-0.74 -2.112,-1.36 l 0,0 c -0.871,-0.684 -1.93,-1.719 -1.93,-2.707 l 0,0 0,-8.29 c 0.188,-0.547 23.848,-69.109 23.848,-69.109 l 0,0 -20.844,0 c 0,0 -1.878,1.42 -3.135,2.371 l 0,0 0,-11.527 32.396,0 c 0.894,0 1.646,0.127 2.235,0.375 l 0,0 c 0.586,0.251 1.053,0.566 1.422,0.96 l 0,0 c 0.394,0.424 0.683,0.865 0.859,1.312 l 0,0 c 0.174,0.453 0.265,0.882 0.265,1.265 l 0,0 0,7.889 c -0.192,0.552 -24.371,69.832 -24.371,69.832 l 0,0 21.353,0 c 0,0 1.995,-1.478 3.403,-2.521 l 0,0 0,11.849 -31.75,0 z m -3.833,-1.751 0.128,0.099 -0.128,-0.099 z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g426"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath430)",
    id: "g428"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(384.7544,302.3423)",
    id: "g434"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path436",
    style: {
      fill: "#1d418c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 29.195,0 -5.29,-5.99 0,-75.989 11.584,0 0,76.086 -5.55,5.893 29.331,0 -5.55,-5.886 0,-82.841 7.223,-5.99 -37.989,0 c -11.773,0 -17.661,1.862 -17.661,5.589 l 0,83.138 L 0,0 z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g438"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g440"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g448"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path456",
    style: {
      fill: "url(#linearGradient450)",
      stroke: "none"
    },
    d: "m 419.178,300.464 c 1.31,-1.391 3.123,-3.317 3.123,-3.317 l 0,0 0,-78.663 -15.7,0 0,78.531 c 0,0 1.75,1.983 3.045,3.449 l 0,0 -20.586,0 c 1.294,-1.466 3.046,-3.449 3.046,-3.449 l 0,0 0,-83.801 c 0,-2.323 5.833,-3.711 15.602,-3.711 l 0,0 32.663,0 c -1.628,1.35 -3.955,3.281 -3.955,3.281 l 0,0 0,84.368 c 0,0 1.813,1.925 3.12,3.312 l 0,0 -20.358,0 z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g458"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath462)",
    id: "g460"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(468.8008,288.7373)",
    id: "g466"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path468",
    style: {
      fill: "#1d418c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 0,-25.055 3.59,0 c 2.228,0 4.133,0.414 5.717,1.245 1.586,0.832 2.866,1.879 3.85,3.148 0.988,1.262 1.71,2.641 2.186,4.141 0.468,1.497 0.704,2.943 0.704,4.342 0,1.467 -0.236,2.929 -0.704,4.394 -0.476,1.466 -1.224,2.778 -2.248,3.942 -1.03,1.165 -2.358,2.098 -3.985,2.795 C 7.484,-0.35 5.471,0 3.081,0 L 0,0 z m -0.378,-32.006 0,-43.218 5.284,-5.888 -29.189,0 5.292,5.888 0,82.839 -5.292,5.99 27.933,0 C 27.575,13.788 31.418,-1.057 31.934,-2.854 32.457,-4.651 33.659,-13.587 31.27,-18.729 29.981,-21.501 23.326,-34.046 5.792,-37.495 l -6.17,5.489 z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g470"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g472"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g478"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g480"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path488",
    style: {
      fill: "url(#linearGradient482)",
      stroke: "none"
    },
    d: "m 473.223,300.464 -24.401,0 c 1.294,-1.466 3.046,-3.449 3.046,-3.449 l 0,0 0,-84.174 c 0,0 -1.735,-1.931 -2.999,-3.338 l 0,0 20.49,0 c -1.263,1.408 -2.995,3.34 -2.995,3.34 l 0,0 0,48.344 c 0,0 7.26,-6.458 8.664,-7.709 l 0,0 c 17.265,5.047 21.889,14.771 23.174,17.315 l 0,0 c 1.239,2.475 3.707,16.805 -6.19,24.398 l 0,0 c -6.484,4.975 -16.064,5.279 -18.307,5.279 l 0,0 c -0.312,0 -0.482,-0.006 -0.482,-0.006 m -6.479,-9.848 5.138,0 c 2.686,0 5.011,-0.413 6.906,-1.226 l 0,0 c 1.904,-0.816 3.489,-1.933 4.71,-3.317 l 0,0 c 1.189,-1.348 2.069,-2.892 2.619,-4.588 l 0,0 c 0.526,-1.642 0.789,-3.296 0.789,-4.927 l 0,0 c 0,-1.559 -0.263,-3.193 -0.783,-4.858 l 0,0 c -0.543,-1.713 -1.381,-3.297 -2.488,-4.716 l 0,0 c -1.15,-1.482 -2.666,-2.722 -4.503,-3.685 l 0,0 c -1.889,-0.992 -4.159,-1.494 -6.742,-1.494 l 0,0 -5.646,0 0,28.811 z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g490"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath494)",
    id: "g492"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(526.5684,255.374)",
    id: "g498"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path500",
    style: {
      fill: "#1d418c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 0,-34.837 12.393,0 6.319,4.693 0,-17.605 -42.421,0 5.289,5.995 0,41.581 -6.065,0 6.065,12.656 0,28.407 -5.289,6.078 42.421,0 0,-17.292 -6.319,4.295 -12.393,0 0,-20.799 20.393,0 L 13.033,0 0,0 z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g510"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g512"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path520",
    style: {
      fill: "url(#linearGradient514)",
      stroke: "none"
    },
    d: "m 507.125,300.464 c 1.317,-1.516 3.083,-3.545 3.083,-3.545 l 0,0 0,-29.454 c 0,0 -3.395,-7.083 -4.979,-10.386 l 0,0 4.979,0 0,-44.122 c 0,0 -1.752,-1.984 -3.047,-3.454 l 0,0 36.061,0 0,11.776 c -1.475,-1.096 -3.529,-2.62 -3.529,-2.62 l 0,0 -15.182,0 0,38.594 13.829,0 c 0.755,1.351 3.53,6.318 5.26,9.414 l 0,0 -19.089,0 0,24.556 15.133,0 c 0,0 2.065,-1.404 3.578,-2.431 l 0,0 0,11.672 -36.097,0 z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g522"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath526)",
    id: "g524"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(575.5244,263.6826)",
    id: "g530"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path532",
    style: {
      fill: "#1d418c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 2.251,0 4.171,0.414 5.77,1.245 1.596,0.832 2.913,1.879 3.95,3.148 1.041,1.261 1.793,2.641 2.269,4.14 0.474,1.497 0.719,2.944 0.719,4.343 0,1.467 -0.245,2.929 -0.719,4.394 -0.476,1.465 -1.228,2.778 -2.269,3.942 -1.037,1.165 -2.399,2.098 -4.081,2.795 -1.686,0.698 -3.739,1.048 -6.155,1.048 l -3.108,0 L -3.624,0 0,0 z m 15.627,-6.646 17.945,-42.224 -0.132,0 0.649,-1.197 7.098,-5.991 -24.271,0 0,4.993 -20.923,42.127 0,-41.231 5.288,-5.889 -29.322,0 5.423,5.889 0,82.839 -5.422,5.99 28.173,0 c 0.604,0 1.075,-0.029 1.423,-0.086 1.466,-0.067 3.038,-0.2 4.715,-0.401 0,0 20.895,-1.591 23.031,-20.71 C 31.107,1.298 15.627,-6.646 15.627,-6.646"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g534"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g536"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g542"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g544"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path552",
    style: {
      fill: "url(#linearGradient546)",
      stroke: "none"
    },
    d: "m 575.657,300.464 -23.801,0 c 1.318,-1.457 3.108,-3.436 3.108,-3.436 l 0,0 0,-84.2 c 0,0 -1.775,-1.927 -3.062,-3.325 l 0,0 20.555,0 c -1.265,1.408 -2.998,3.338 -2.998,3.338 l 0,0 0,41.904 3.933,0.776 21.107,-42.497 0,-3.521 16.952,0 c -1.606,1.355 -3.515,2.97 -3.515,2.97 l 0,0 -0.859,1.583 0.1,0.076 -18.533,43.606 c 17.898,10.043 13.924,25.937 13.924,25.937 l 0,0 c -4.397,15.782 -21.494,16.812 -25.881,16.812 l 0,0 c -0.658,0 -1.03,-0.023 -1.03,-0.023 m -5.815,-9.848 5.167,0 c 2.701,0 5.057,-0.408 7.005,-1.215 l 0,0 c 1.969,-0.817 3.593,-1.934 4.829,-3.322 l 0,0 c 1.198,-1.342 2.09,-2.888 2.644,-4.592 l 0,0 c 0.533,-1.647 0.803,-3.304 0.803,-4.929 l 0,0 c 0,-1.552 -0.268,-3.189 -0.798,-4.864 l 0,0 c -0.547,-1.722 -1.423,-3.321 -2.603,-4.75 l 0,0 c -1.195,-1.462 -2.736,-2.691 -4.575,-3.648 l 0,0 c -1.905,-0.991 -4.188,-1.491 -6.789,-1.491 l 0,0 -5.683,0 0,28.811 z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g554"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath558)",
    id: "g556"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(581.2549,199.8564)",
    id: "g562"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path564",
    style: {
      fill: "#1d418c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -0.395,-0.005 -39.474,-0.896 -43.762,-35.671 -0.046,-0.362 -4.127,-37.129 47.603,-46.86 l 21.586,-3.754 c 0,0 -0.823,28.975 -0.875,30.79 0.81,0.668 5.792,4.771 5.792,4.771 l -28.175,2.662 c 0,0 0.4,-16.27 0.494,-20.09 -6.157,1.506 -22.57,7.622 -22.57,30.128 0,0.4 0.006,0.806 0.016,1.216 2.146,23.648 18.841,23.591 19.551,23.578 0,0 17.033,-0.155 18.012,-0.164 0.737,-0.421 7.366,-4.214 7.366,-4.214 L 24.529,0 0,0 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(302.5059,191.0342)",
    id: "g566"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path568",
    style: {
      fill: "#1d418c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C -3.541,2.786 -7.121,5.665 -10.741,8.646 9.275,8.658 28.598,8.667 47.268,8.677 43.845,6.215 40.409,3.678 36.954,1.053 c -0.262,-11.159 -0.523,-22.325 -0.789,-33.498 7.742,12.356 15.479,23.85 23.154,34.609 0.065,2.174 0.13,4.346 0.197,6.519 C 74.208,8.688 88.495,8.693 102.404,8.7 99.171,6.633 92.391,2.165 92.271,2.085 92.4,2.152 73.531,-24.625 63.792,-39.903 c 8.677,-18.412 17.175,-35.26 25.62,-50.931 3.141,-1.084 6.277,-2.144 9.401,-3.181 -14.044,-4.498 -28.296,-9.662 -42.679,-15.506 0.065,2.223 0.133,4.444 0.2,6.667 -6.834,12.844 -13.758,26.577 -20.855,41.375 -0.392,-16.593 -0.783,-33.205 -1.178,-49.822 3.228,-1.153 6.44,-2.261 9.639,-3.327 -18.165,-7.834 -36.503,-16.748 -54.864,-26.773 3.324,4.798 6.664,9.463 10.023,14 C -0.751,-106.046 -0.103,-14.687 0,0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g572"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g578"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g580"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path588",
    style: {
      fill: "url(#linearGradient582)",
      stroke: "none"
    },
    d: "m 363.845,197.838 c -0.057,-1.891 -0.16,-5.267 -0.16,-5.267 l 0,0 -0.331,-0.464 c -7.987,-11.196 -15.755,-22.809 -23.091,-34.517 l 0,0 -3.633,-5.797 0.973,41.259 c 0,0 3.627,2.679 6.464,4.777 l 0,0 c -0.344,-0.001 -38.426,-0.021 -46.974,-0.024 l 0,0 c 3.116,-2.509 7.282,-5.864 7.282,-5.864 l 0,0 0.009,-0.92 -0.905,-127.998 c 0,0 -3.05,-4.26 -5.709,-7.975 l 0,0 c 14.363,7.622 28.956,14.709 43.561,21.137 l 0,0 c -2.567,0.886 -6.455,2.226 -6.455,2.226 l 0,0 0.052,1.366 1.179,49.823 3.573,0.769 c 7.017,-14.634 14.022,-28.53 20.819,-41.306 l 0,0 0.234,-0.441 c 0,0 -0.077,-2.545 -0.13,-4.341 l 0,0 c 11.596,4.65 23.279,8.889 34.881,12.73 l 0,0 c -2.063,0.697 -4.881,1.65 -4.881,1.65 l 0,0 -0.341,0.649 c -8.699,16.144 -17.093,32.833 -25.663,51.019 l 0,0 -0.442,0.937 0.557,0.875 c 9.179,14.402 29.018,42.541 29.018,42.541 l 0,0 c 0,0 2.435,1.588 4.858,3.171 l 0,0 c -7.32,-0.003 -31.863,-0.013 -34.745,-0.015"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g590"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath594)",
    id: "g592"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(403.394,97.6748)",
    id: "g598"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path600",
    style: {
      fill: "#1d418c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 2.979,2.957 5.952,5.833 8.91,8.643 1.001,29.219 1.999,58.382 2.994,87.493 -2.768,1.927 -5.552,3.902 -8.346,5.924 15.67,0.005 30.867,0.01 45.616,0.013 C 46.499,100.286 43.801,98.47 41.083,96.617 40.324,69.834 39.56,43.018 38.796,16.153 41.495,14.94 44.179,13.735 46.861,12.538 31.563,9.198 15.913,5.028 0,0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g602"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g604"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g610"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g612"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path620",
    style: {
      fill: "url(#linearGradient614)",
      stroke: "none"
    },
    d: "m 412.844,197.858 c 1.722,-1.224 4.352,-3.091 4.352,-3.091 l 0,0 -0.021,-1.021 -3.02,-88.25 c 0,0 -2.326,-2.257 -3.884,-3.767 l 0,0 c 11.42,3.433 22.836,6.464 34.111,9.057 l 0,0 c -1.376,0.617 -4.108,1.841 -4.108,1.841 l 0,0 0.597,20.915 1.754,61.768 c 0,0 2.394,1.614 3.793,2.556 l 0,0 c -8.266,-0.001 -29.103,-0.007 -33.574,-0.008"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g622"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath626)",
    id: "g624"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(480.4951,199.8457)",
    id: "g630"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path632",
    style: {
      fill: "#1d418c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 8.258,-9.816 16.484,-19.258 24.709,-28.603 0.003,3.791 0.01,7.58 0.014,11.369 0.113,4.132 0.229,8.267 0.338,12.395 -2.412,1.606 -4.822,3.216 -7.245,4.839 l 40.301,0 c -2.26,-1.657 -4.538,-3.309 -6.833,-4.964 0.342,-27.251 0.676,-54.485 1.018,-81.695 -0.721,-0.089 -1.44,-0.184 -2.16,-0.277 -13.667,16.189 -27.433,31.613 -41.221,47.577 -0.12,-12.823 -0.245,-25.652 -0.364,-38.488 2.614,-1.316 5.225,-2.646 7.832,-3.983 -14.512,-1.649 -29.453,-4.102 -44.75,-7.377 2.812,2.367 5.6,4.679 8.374,6.937 0.575,25.711 1.141,51.398 1.711,77.044 -2.604,1.715 -5.215,3.457 -7.838,5.226 L 0,0 z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g634"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g636"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g642"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g644"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path652",
    style: {
      fill: "url(#linearGradient646)",
      stroke: "none"
    },
    d: "m 504.507,197.968 c 0.858,-0.574 2.953,-1.974 2.953,-1.974 l 0,0 -0.026,-1.037 c 0,0 -0.338,-12.408 -0.338,-12.428 l 0,0 c 0,-0.445 -0.019,-16.258 -0.019,-16.258 l 0,0 -3.285,3.73 c -7.107,8.079 -15.52,17.702 -24.168,27.967 l 0,0 -19.037,0 c 1.198,-0.799 3.524,-2.351 3.524,-2.351 l 0,0 -0.013,-1.038 -1.731,-77.902 c 0,0 -2.159,-1.789 -3.279,-2.717 l 0,0 c 10.623,2.107 21.16,3.828 31.496,5.151 l 0,0 c -1.007,0.512 -3.417,1.738 -3.417,1.738 l 0,0 0.006,1.167 0.411,43.436 18.49,-21.238 c 8.148,-9.32 16.556,-18.956 24.814,-28.711 l 0,0 c -0.052,4.175 -1,80.328 -1,80.328 l 0,0 c 0,0 2.015,1.464 2.941,2.137 l 0,0 -28.322,0 z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g654"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath658)",
    id: "g656"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(621.2285,122.1182)",
    id: "g662"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path664",
    style: {
      fill: "#1d418c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 5.979,-1.477 11.806,-3.125 17.473,-4.951 -8.06,25.292 -16.731,47.98 -25.698,68.932 -0.068,2.635 -0.132,5.269 -0.199,7.903 -0.031,1.274 0.873,2.511 2.711,3.733 1.742,1.328 3.584,2.013 5.507,2.013 12.012,-0.005 23.675,-0.008 34.999,-0.014 l 0,-18.613 c -1.949,1.742 -3.922,3.437 -5.907,5.084 -6.084,0.34 -8.806,0.647 -15.108,0.927 8.617,-22.436 16.798,-47.048 24.175,-74.75 0,-3.002 0.167,-10.497 -0.069,-11.097 -0.236,-0.605 -0.603,-1.102 -1.113,-1.481 -0.502,-0.383 -1.148,-0.591 -1.929,-0.633 -0.783,-0.039 -1.723,0.189 -2.825,0.676 -10.925,4.798 -26.319,9.018 -38.621,12.146 C -6.731,-4.87 -6.863,0.392 -6.998,5.654 -4.844,3.867 -2.705,2.032 -0.59,0.144 -0.396,0.099 -0.194,0.05 0,0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g674"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g676"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path684",
    style: {
      fill: "url(#linearGradient678)",
      stroke: "none"
    },
    d: "m 616.719,196.157 -0.051,-0.039 -0.054,-0.035 c -1.145,-0.761 -1.826,-1.515 -1.826,-2.019 l 0,0 c 0,-0.004 0.174,-6.911 0.19,-7.546 l 0,0 c 9.788,-22.903 18.172,-45.396 25.614,-68.748 l 0,0 1.171,-3.674 -3.67,1.182 c -5.562,1.792 -11.396,3.445 -17.34,4.913 l 0,0 c -0.017,0.005 -1.026,0.251 -1.026,0.251 l 0,0 -0.41,0.339 c 0,0 -1.5,1.291 -2.992,2.574 l 0,0 c 0.099,-3.985 0.203,-8.126 0.245,-9.814 l 0,0 c 11.167,-2.862 26.532,-7.072 37.473,-11.878 l 0,0 c 1.022,-0.45 1.612,-0.526 1.928,-0.511 l 0,0 c 0.253,0.014 0.61,0.066 0.826,0.231 l 0,0 c 0.19,0.142 0.304,0.324 0.402,0.536 l 0,0 c 0.04,0.476 0.055,1.516 0.055,2.774 l 0,0 c 0,1.492 -0.017,3.238 -0.033,4.536 l 0,0 c 0,0 -0.018,2.409 -0.022,2.872 l 0,0 c -6.864,25.747 -14.729,50.062 -24.045,74.32 l 0,0 -1.103,2.873 11.783,-0.697 7.055,-0.454 0.491,-0.41 c 0,0 1.345,-1.157 2.657,-2.287 l 0,0 0,12.305 c -3.272,0.001 -33.015,0.012 -33.015,0.012 l 0,0 c -1.478,0 -2.885,-0.524 -4.303,-1.606"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g686"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g688"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g694"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g696"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path704",
    style: {
      fill: "url(#linearGradient698)",
      stroke: "none"
    },
    d: "m 581.279,197.872 c 0,0 -37.691,-0.471 -41.816,-33.93 l 0,0 c 0,0 -4.5,-35.166 46,-44.667 l 0,0 19.166,-3.332 -0.833,29.332 2.833,2.334 -21.166,2.001 0.5,-20.335 c 0,0 -27.414,3.406 -26.582,33.906 l 0,0 c 2.331,25.969 21.582,25.428 21.582,25.428 l 0,0 18.5,-0.167 4.744,-2.714 -0.35,12.144 -22.578,0 z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g706"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath710)",
    id: "g708"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(476,418.626)",
    id: "g714"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path716",
    style: {
      fill: "#1c63b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 -5.126,5.262 -10.627,0.392 -5.498,-4.854 0,0 z m -6.415,-36.786 -4.462,4.588 4.788,4.239 4.485,-4.583 -4.811,-4.244 z m 37.173,-10.72 c -14.678,5.606 -8.298,19.398 -8.298,19.398 0,0 -2.378,-5.108 -10.4,-4.29 -16.059,1.63 -17.131,24.27 -17.131,24.27 -3.033,-14.553 -9.418,-21.239 -18.09,-22.645 -9.505,-1.536 -11.645,5.43 -11.645,5.43 0,0 3.587,-11.635 -7.074,-17.266 -9.803,-5.192 -16.736,4.768 -16.736,4.768 l 14.65,-25.172 c 8.531,9.075 20.215,17.803 36.159,17.844 16.069,0.041 30.489,-7.678 38.191,-17.784 l 0.076,-0.004 13.151,19.519 c -6.941,-6.628 -12.853,-4.068 -12.853,-4.068 m -0.634,23.549 -1.587,5.329 -5.586,-1.5 1.588,-5.324 5.585,1.495 z m 19.8,-10.335 -5.958,-1.117 1.186,-5.919 5.952,1.111 -1.18,5.925 z m -83.999,17.149 -5.355,2.136 -2.228,-5.092 5.363,-2.133 2.22,5.089 z m -28.987,-12.236 -1.592,-5.302 5.579,-1.538 1.596,5.307 -5.583,1.533 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(394.3628,335.3379)",
    id: "g718"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path720",
    style: {
      fill: "#1c63b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 0,12.189 -3.079,2.557 16.987,0 -3.092,-2.555 0,-11.891 6.673,0 0,11.891 -3.128,2.555 17.06,0 -3.227,-2.515 0,-35.465 3.227,-2.473 -17.034,0 3.154,2.473 0,17.77 -6.725,0 0,-17.734 3.092,-2.509 -16.987,0 L 0,-23.198 0,-5.464 -3.529,-5.46 0,0 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(439.8887,330.0176)",
    id: "g722"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path724",
    style: {
      fill: "#1c63b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 0,-14.876 7.214,0 3.677,2.002 0,-7.513 -24.73,0 3.079,2.558 0,17.759 -3.528,0 3.528,5.407 0,12.135 -3.079,2.594 24.73,0 0,-7.378 -3.677,1.834 -7.214,0 0,-8.901 11.867,0 L 7.581,0 0,0 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(462.2344,350.1211)",
    id: "g726"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path728",
    style: {
      fill: "#1c63b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 9.766,-14.145 0,5.456 0.076,6.132 L 6.766,0 l 17.429,0 -3.078,-2.599 0,-41.582 -1.054,-0.132 -16.383,24.8 0,-18.45 3.086,-2.514 -16.976,0 3.078,2.514 0,35.406 L -10.21,0 0,0 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(496.9248,350.1211)",
    id: "g730"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path732",
    style: {
      fill: "#1c63b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 9.761,-14.145 0,5.456 0.076,6.132 -3.07,2.557 17.429,0 -3.082,-2.599 0,-41.582 -1.052,-0.132 -16.378,24.8 0,-18.45 3.077,-2.514 -16.968,0 3.076,2.514 0,35.406 L -10.207,0 0,0 z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path734",
    style: {
      fill: "#1c63b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 535.301,335.638 6.666,0 0,9.041 -6.666,0 0,-9.041 z m 3.576,-26.007 3.15,2.473 0,17.77 -6.726,0 0,-17.734 3.076,-2.509 -16.975,0 3.08,2.509 0,17.734 -3.531,0 3.586,5.46 0,11.339 c 0.051,0.936 1.227,1.779 3.535,2.515 2.098,0.598 4.338,0.895 6.684,0.895 l 7.808,0 c 1.09,-0.027 2.161,-0.12 3.184,-0.275 1.027,-0.158 2.08,-0.392 3.184,-0.704 2.138,-0.599 3.392,-1.406 3.744,-2.431 l 0,-34.613 3.234,-2.429 -17.033,0 z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(556.1895,309.6309)",
    id: "g736"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path738",
    style: {
      fill: "#1c63b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 3.012,2.509 0,35.387 -3.012,2.557 16.32,0 -2.931,-2.557 0,-35.387 L 16.32,0 0,0 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(390.1899,341.3247)",
    id: "g740"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path742",
    style: {
      fill: "#1c63b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 0,8.833 c 0,0 -22.667,2.5 -24.25,-19.916 0,0 -0.333,-18.25 18.917,-20.5 L 0,-31.75 l 0,9 -3.75,-2.167 c 0,0 -9.666,-0.833 -10.333,13.584 0,0 0.416,13.916 10.416,13.583 L 0,0 z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChennaiSuperKingsLogo);
export default __webpack_public_path__ + "static/media/Chennai_Super_Kings_Logo.fa3731a602dd36a2d433012203e1346c.svg";
export { ForwardRef as ReactComponent };